/*
=========================================================
NUPEP Subscription Landing Page
Version 3.0
=========================================================
*/

document.addEventListener("DOMContentLoaded", () => {
  console.log("NUPEP Subscription Page Loaded");

  // ==========================================
  // Open / Close Delivery Schedule
  // ==========================================

  document.querySelectorAll(".subscription-card-button").forEach((button) => {
    button.addEventListener("click", () => {
      const picker = button.parentElement.querySelector(
        ".subscription-plan-picker",
      );

      if (picker) {
        picker.classList.toggle("is-open");
      }
    });
  });

  // ==========================================
  // Select Delivery Schedule
  // ==========================================

  document.querySelectorAll(".subscription-plan-card").forEach((card) => {
    card.addEventListener("click", () => {
      const wrapper = card.closest(".subscription-plan-picker");

      wrapper
        .querySelectorAll(".subscription-plan-card")
        .forEach((c) => c.classList.remove("active"));

      card.classList.add("active");

      const radio = card.querySelector("input");

      if (radio) {
        radio.checked = true;
      }
    });
  });

  // ==========================================
  // Subscribe Now
  // ==========================================

  document.querySelectorAll(".subscription-confirm").forEach((button) => {
    button.addEventListener("click", async (e) => {
      e.preventDefault();

      const form = button.closest("form");

      if (!form) return;

      const variantId = form.dataset.variantId;

      const activePlan = form.querySelector(".subscription-plan-card.active");

      if (!activePlan) {
        console.warn("No subscription plan selected.");
        return;
      }

      const sellingPlanId = activePlan.getAttribute("data-selling-plan");

      console.log("Selected Label:", activePlan);

      console.log("Selling Plan ID:", sellingPlanId);

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          selling_plan: Number(sellingPlanId),
        }),
      });

      const result = await response.json();

      console.log(result);

      if (response.ok) {
        window.location.href = "/cart";
      } else {
        alert(result.description || "Unable to add subscription.");
      }
    });
  });
});
